<!--
 * @Description 合同详情-销售单tab
-->
<template>
  <div
    v-loading="loading"
    v-empty="nopermission"
    class="rc-cont"
    xs-empty-icon="nopermission"
    xs-empty-text="暂无权限">
    <el-table
      v-show="fieldList.length > 0"
      :data="list"
      :height="tableHeight"
      :cell-class-name="cellClassName"
      stripe>
      <el-table-column
        v-for="(item, index) in fieldList"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="item.width"
        show-overflow-tooltip>
        <template slot-scope="{ row, column }">
          <template v-if="item.prop === 'number'">
						<div>
              <div class="ellipsis" :style="{color: '#2441B3', cursor: 'pointer'}" >
                <span @click="jumpSaleDetail(row.id)">{{ row.number }}</span>
                <span 
                  class="ml-8"
                  v-clipboard:copy="`${row.number}`"
                  v-clipboard:success="clipboardSuccess"
                >
                  <IconSvg name="iconic_copy" class="fn-14 pointer"/>
                </span>
              </div>
              <div class="ellipsis">{{ row.enterName }}</div>
            </div>
					</template>
          <template v-else-if="item.prop === 'spotName'">
						<div>
              <div class="ellipsis"  :style="{color: '#2441B3', cursor: 'pointer'}" @click="jumpSpotDetail(row.spotId)">{{ row.spotName === row.placeName ? row.spotName : `${row.placeName}-${row.spotName}` }}</div>
            </div>
					</template>
          <template v-else-if="item.prop === 'isArchived'">
             <el-tag  :type=" row.isArchived === 1 ? 'success' : 'danger'" size="medium">{{ row.isArchived === 1 ? '已归档' : '未存档' }}</el-tag>
					</template>
          <template v-else-if="item.prop === 'price'">
						<div>
              <div>收入合计：{{ row.price && row.price.saleFee? beautifyThePrice(row.price.saleFee, ',', 2, '¥') : '-'}} 
                <el-tooltip effect="dark" placement="top" trigger="hover">
                  <div slot="content">
                    <div>场地费：{{ row.price && row.price.placeFee? beautifyThePrice(row.price.placeFee, ',', 2, '¥') : '-' }}</div>
                    <div>第三方成本：{{ row.price && row.price.thirdPartFee? beautifyThePrice(row.price.thirdPartFee, ',', 2, '¥') : '-' }}</div>
                    <div>他项：{{ row.price && row.price.publicRelationFee? beautifyThePrice(row.price.publicRelationFee, ',', 2, '¥') : '-' }}</div>
                  </div>
                    <IconSvg name="iconjy_ic_shuomingfuhao_normal" class="fn-14 pointer"/>
                </el-tooltip>
              </div>
              <div>押金：{{ row.price && row.price.depositFee? beautifyThePrice(row.price.depositFee, ',', 2, '¥') : '-'}} </div>
            </div>
					</template>
          <template v-else-if="item.prop === 'roleRelationList'">
						<div v-if="Array.isArray(row.roles) && row.roles.length">
              <div class="ellipsis" v-for="(item,index) in row.roles" :key="index">
                {{ item.name }}：{{ Array.isArray(item.employees) && item.employees.length?item.employees.map(item=>item.name).join('、') : '-' }}
              </div>
            </div>
            <div v-else>
              -
            </div>
					</template>
          <template v-else-if="item.prop === 'mark'">
           <div v-if="row.mark">{{ row.mark }}</div>
           <div v-else>-</div>

					</template>
          <template v-else-if="item.prop === 'status'">
            <span :style="getStatusStyle(row.status)" class="status-mark" />
            <span>{{ row.statusName }}</span>
					</template>
					<template v-else>
						{{ row[item.prop] }}
					</template>
				</template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script type="text/javascript">

import { crmContractQuerySalesAPI } from '@/api/crm/contract'
import { beautifyThePrice } from '@lhb/func'
import clipboard from '@/directives/clipboard/index.js'; // use clipboard by v-directive

export default {
  name: 'ContractSales', // 销售单相关
  components: {
  },
  directives: {
    clipboard
  },
  mixins: [],
  props: {
    id: [String, Number],
    detail: {
      type: Object,
      default: ()=>({})
    }
  },
  data() {
    return {
      loading: false,
      nopermission: false,
      list: [],
      fieldList: [],
      tableHeight: '400px',
      beautifyThePrice,
      statusMap: new Map([
        [2, 'warning'],
        [3, 'warning'],
        [4, 'processing'],
        [5, 'success'],
        [6, 'error'],
        [7, 'default']
      ])
    }
  },
  computed: {
    
  },
  watch: {
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    /**
     * 复制地址
     */
     clipboardSuccess() {
      this.$message.success('复制成功');
    },
    getStatusStyle(status) {
      const type = this.statusMap.get(status);
      if(type === 'default') {
        return {background: 'rgba(149, 155, 171, 1)'}
      } else if(type === 'success') {
        return {background: 'rgba(82, 196, 26, 1)'}
      } else if(type === 'warning') {
        return {background: 'rgba(255, 134, 29, 1)'}
      } else if(type === 'error') {
        return {background: 'rgba(255, 77, 79, 1)'}
      } else if(type === 'processing') {
        return {background: 'rgba(0, 57, 194, 1)'}
      }
    },
    jumpSaleDetail(id) {
      window.open(`/lhb-micro-pms/sales/detail?id=${id}`, '_blank');
    },
    jumpSpotDetail(id) {
      window.open(`/lhb-micro-pms/pointMng/detail?tenantSpotId=${id}`, '_blank');
    },

    /**
     * 表头数据
     */
    getFieldList() {
      this.fieldList.push({ prop: 'number', label: '订单编号及客户名称', width: 250 })
      this.fieldList.push({ prop: 'spotName', label: '项目点位', width: 150 })
      this.fieldList.push({ prop: 'title', label: '活动名称', width: 150 })
      this.fieldList.push({ prop: 'isArchived', label: '是否归档' })
      this.fieldList.push({ prop: 'start', label: '活动开始日期', width: 120 })
      this.fieldList.push({ prop: 'end', label: '活动结束日期', width: 120 })
      this.fieldList.push({ prop: 'price', label: '价格', width: 220 })
      this.fieldList.push({ prop: 'roleRelationList', label: '跟进人', width: 150 })
      this.fieldList.push({ prop: 'mark', label: '备注', width: 200 })
      this.fieldList.push({ prop: 'status', label: '当前状态', width: 80 })
      this.fieldList.push({ prop: 'createdAt', label: '创建时间', width: 120 })
      this.fieldList.push({ prop: 'approvedAt', label: '审核通过时间', width: 120 })
      this.fieldList.push({ prop: 'updatedAt', label: '最新修改时间', width: 120 })





    },

    /**
     * 获取数据
     */
    getDetail(loading = true) {
      if (this.fieldList.length == 0) {
        this.getFieldList()
      }
      this.loading = loading
      crmContractQuerySalesAPI({id: this.id, contractKeyword: this.detail.num, page: 1, size: 999}).then((res) => {
        const { objectList = [] } = res;
        this.list = objectList || [];
        this.loading = false;
      })
    },

    /**
     * 通过回调控制class
     */
    cellClassName({ row, column, rowIndex, columnIndex }) {
      if (column.property === 'num') {
        return 'can-visit--underline'
      } else {
        return ''
      }
    },
  }
}
</script>
<style lang="scss" scoped>
@import "../../styles/relativecrm.scss";
@import "../../styles/table.scss";

.tips {
  color: #909399;
  width: 100%;
  text-align: right;
  margin-top: 10px;
}

</style>

